import { api } from "@/api"

export const resetMerchantGroupAdminPassword =
  async (params: { token: string; password: string }) => {
    return await api.post(
      "/merchant-group/handle-password-reset/",
      { body: params }
    )
  }
